import { render, staticRenderFns } from "./FormasPago.vue?vue&type=template&id=1ce6c446&scoped=true&lang=pug"
import script from "./FormasPago.vue?vue&type=script&lang=js"
export * from "./FormasPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce6c446",
  null
  
)

export default component.exports